import { Candidate, ExamCandidatesArgs, Scalars } from '@generated/base-types';
import {
  CandidatesCreateAccessDocumentPayload,
  CandidatesCreateMasterDocumentPayload
} from '@new/common/candidate-document-payload';
import { ManagerError } from '@new/common/utils/error-parser';
import { Exam } from '@new/pools/lib/types';

export class LoadExamCandidates {
  public static readonly type = '[ExamCandidates] Load';
  constructor(public readonly examId: Scalars['ID']) {}
}

export class LoadExamCandidatesSuccess {
  public static readonly type = '[ExamCandidates] Load success';
  constructor(public readonly candidates: Candidate[]) {}
}

export class LoadExamCandidatesFailure {
  public static readonly type = '[ExamCandidates] Load failure';
  constructor(public readonly error: ManagerError) {}
}

export class SetSelectedCandidateIds {
  public static readonly type = '[ExamCandidates] Set selected IDs';
  constructor(public readonly ids: string[]) {}
}

export class ResetSelectedCandidateIds {
  public static readonly type = '[ExamCandidates] Reset selected IDs';
}

export class ImportCandidates {
  public static readonly type = '[ExamCandidates] Import candidates';
  constructor(
    public readonly file: File,
    public readonly examId: Scalars['ID']
  ) {}
}

export class ImportCandidatesSuccess {
  public static readonly type = '[ExamCandidates] Import candidates success';
}

export class ImportCandidatesFailure {
  public static readonly type = '[ExamCandidates] Import candidates failure';
  constructor(public readonly error: ManagerError) {}
}

export class ResetMutation {
  public static readonly type = '[ExamCandidates] Reset Mutation';
}

export class SetExamCandidatesOrder {
  public static readonly type = '[ExamCandidates] Set order';
  constructor(public readonly order: ExamCandidatesArgs['order']) {}
}

export class ResetExamCandidatesOrder {
  public static readonly type = '[ExamCandidates] Reset order';
}

export class CreateAccessDocuments {
  public static readonly type = '[ExamCandidates] Create access documents';
  constructor(public payload: CandidatesCreateAccessDocumentPayload) {}
}

export class CreateAccessDocumentsSuccess {
  public static readonly type =
    '[ExamCandidates] Create access documents success';
}

export class CreateAccessDocumentsFailure {
  public static readonly type =
    '[ExamCandidates] Create access documents failure';
  constructor(public error: ManagerError) {}
}

export class DeleteCandidates {
  public static readonly type = '[ExamCandidates] Delete candidate';
  constructor(public examId: Exam['id'], public candidateIds: string[]) {}
}

export class DeleteCandidatesSuccess {
  public static readonly type = '[ExamCandidates] Delete candidate success';
  constructor(public candidateIds: string[]) {}
}

export class DeleteCandidatesFailure {
  public static readonly type = '[ExamCandidates] Delete candidate failure';
  constructor(public error: ManagerError) {}
}

export class CreateMasterDocument {
  public static readonly type = '[ExamCandidates] Create master document';
  constructor(public payload: CandidatesCreateMasterDocumentPayload) {}
}

export class CreateMasterDocumentSuccess {
  public static readonly type =
    '[ExamCandidates] Create master document success';
}

export class CreateMasterDocumentFailure {
  public static readonly type =
    '[ExamCandidates] Create master document failure';
  constructor(public error: ManagerError) {}
}
